import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-768d25b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SamplesList" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Status Clean" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Status Contaminated" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Status Hazardous" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Status Unknown" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Status Unknown" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverviewBox = _resolveComponent("OverviewBox")!

  return (_openBlock(), _createBlock(_component_OverviewBox, {
    class: "SamplesBox",
    link: {
      icon: 'analysis',
      to: 'SamplesAndAssesments',
      title: _ctx.mixWB('VIEW_SAMPLES_AND_ASSESSMENTS'),
    }
  }, _createSlots({
    subHeader: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.mixWB('SUMMARY')), 1)
    ]),
    list: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.data.recap.clean), 1),
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.data.recap.contaminated), 1),
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.data.recap.hazardous), 1),
        (_ctx.data.recap.postponed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.data.recap.postponed), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.recap.missing)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_ctx.data.recap.missing), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (_ctx.data.metaText)
      ? {
          name: "meta",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.metaText), 1)
          ])
        }
      : undefined,
    (!_ctx.data.all.length)
      ? {
          name: "noData",
          fn: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('NO_SAMPLES_REGISTERED')), 1)
          ])
        }
      : undefined
  ]), 1032, ["link"]))
}